const AVERAGE_READING_SPEED = 836; // https://en.wikipedia.org/wiki/Words_per_minute#Reading_and_comprehension
export const timeout = (message) => {
  const result = 60000 * message.length / AVERAGE_READING_SPEED;
  return result < 1000 ? 1000 : result;
};

export default {
  namespaced: true,
  state: {
    message: null,
    timeoutID: null,
  },
  mutations: {
    setErrorMessage(state, message) {
      state.message = message;
    },
    setTimeoutID(state, id) {
      state.timeoutID = id;
    },
    clearTimeout(state) {
      clearTimeout(state.timeoutID);
    },
  },
  actions: {
    setMessage({ commit, dispatch }, error) {
      commit('clearTimeout');
      const { response, message } = error;
      let msg;
      if (response) {
        msg = response.data.message;
      } else {
        msg = message;
      }

      // deprecated
      // todo: delete jwt condition
      if (msg === 'jwt expired') {
        dispatch('user/logout', null, { root: true });
      } else {
        commit('setErrorMessage', msg);

        const timeoutID = setTimeout(() => {
          commit('setErrorMessage', null);
        }, timeout(msg));

        commit('setTimeoutID', timeoutID);
      }
    },
  },
  getters: {
    message: state => state.message,
  },
};
